import type { IPlaybookTrigger, EPlaybookTriggerFilter } from 'src/services/api/playbooks/types';
import rawPlaybooks from 'src/pages/landlord/playbooks/new/playbooks.json';

export type PlaybookLibraryCategory =
    | 'welcome'
    | 'followup'
    | 'confirmation'
    | 'post-tour'
    | 'facebook';

export interface IPlaybookLibraryTemplate {
    id: string;
    title: string;
    description: string;
    category: PlaybookLibraryCategory;
    /** Internal only — drives "Popular" badge (≥1000), never displayed as a number. */
    uses: number;
    trigger: IPlaybookTrigger;
    message: string;
    filters?: EPlaybookTriggerFilter[];
}

export const PLAYBOOK_CATEGORY_META: Record<PlaybookLibraryCategory, { label: string; color: string; bg: string }> = {
    welcome: { label: 'Welcome & Intro', color: '#db2777', bg: '#fdf2f8' },
    followup: { label: 'Follow-ups', color: '#d97706', bg: '#fffbeb' },
    confirmation: { label: 'Tour Confirmation', color: '#059669', bg: '#f0fdf4' },
    'post-tour': { label: 'Post-Tour', color: '#0d9488', bg: '#f0fdfa' },
    facebook: { label: 'Facebook', color: '#2563eb', bg: '#eff6ff' },
};

export const LIBRARY_PLAYBOOKS: IPlaybookLibraryTemplate[] = rawPlaybooks as IPlaybookLibraryTemplate[];

export const LIBRARY_PLAYBOOKS_MAP: Map<string, IPlaybookLibraryTemplate> = new Map(
    LIBRARY_PLAYBOOKS.map((t) => [t.id, t]),
);
